import {
  Box,
    Checkbox,
  ClickAwayListener,
  createTheme,
  Fade,
  Paper,
  Popper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  ThemeProvider,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { EnhancedTableHead } from "../../components/EnhancedTableHead";
import { getComparator, stableSort } from "../../common/SortSupport";
import TableSkeleton from "../../components/TableSkeleton";
import { useSelector } from "react-redux";
import { getActionRestrictions, getCriteriaRestrictions, getEvidenceRestrictions, getStandardRestrictions } from "../../api/evaluation";
import { AvatarAndName } from "../../components/AvatarAndName";
import { baseUrl } from "../../api/config";
import { set } from "lodash";
import { hasUpdates } from "../../common/logics";
import { getCriteriaRestrictionsLicence, getStandardRestrictionsLicence } from "../../api/licence";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faLockOpen } from "@fortawesome/free-solid-svg-icons";
import AlertPopup from "../../components/AlertPopup";

const theme = createTheme({
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: 0,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: "13px !important",
          padding: "10px !important",
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: "0px",
        },
      },
    }
  },
});

const AccessManager = (props: any) => {
  const { isOpen, handleIsOpen, from, itemId, criteriaRestrictions = [] } = props;
  const handleClickInsidePopper = (event: MouseEvent) => {
    event.stopPropagation();
  };
  const [t] = useTranslation();

  //supporting contents
  const [order, setOrder] = React.useState("");
  const [orderBy, setOrderBy] = React.useState("");

  const [isLoading, setIsLoading] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [ogData, setOgData] = React.useState([]);
  const clubDetails = useSelector((state:any) => state.clubDetails);
  const user = useSelector((state:any) => state.common.user);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);  
  const [updatedCriteriaRestrictions, setUpdatedCriteriaRestrictions]:any = useState<any>(null);
  const hideTooltip = (from == 'actions' || from == 'evidences' || from == 'evaluationCriteria' || from == 'licenceCriteria');
  const accessPopupInitialData = {
      isOpen: false,
      accessToUserId: null,
      userDetails: null,
      alertMessage: "",
    };
  const confirmationPopupInitialData = {
      isOpen: false,
      userId: null,
      userDetails: null,
      alertMessage: "",
    };
  const [accessPopup, setAccessPopup]: any = useState(
    accessPopupInitialData
  );
  const [confirmationPopup, setConfirmationPopup]: any = useState(
    confirmationPopupInitialData
  );
  const [unResestrictedUsersForAllStandards, setUnResestrictedUsersForAllStandards] = useState([]);

  const head = [
    {
      key: "name",
      displayName: t("USER_NAME"),
    },
    {
      key: "isRestricted",
      displayName: t("HAS_ACCESS"),
    },
  ];

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const visibleRows: any = React.useMemo(
    () =>
      isOpen && data?.length > 0 ? stableSort(data, getComparator(order, orderBy)) : [],
    [order, orderBy, data, isOpen]
  );

  useEffect(() => {
    if (isOpen) {
        switch(from) {
            case 'evaluationCriteria':
                setIsLoading(true);
                const evalCriteriaParams = {
                    clubId: clubDetails?.id,
                    criteriaId: itemId
                }
                getCriteriaRestrictions(evalCriteriaParams).then((response:any) => {
                    setData(response);
                    setOgData(response);
                    setIsLoading(false);
                }).catch((error:any) => {
                    setIsLoading(false);
                })
                break;
            case 'evaluationStandards':
                setIsLoading(true);
                const evalStandardsParams = {
                    clubId: clubDetails?.id,
                    standardId: itemId
                }
                getStandardRestrictions(evalStandardsParams).then((response:any) => {
                    const restricedUserIds = criteriaRestrictions?.filter((cr1:any) => cr1.isRestricted).map((cr:any) => cr.userId);
                    const tempFilteredResponse = response?.map((resItem:any) => {
                        if(restricedUserIds.includes(resItem.id)) {
                            return {...resItem, isDisabled: true};
                          } return resItem;
                        });
                    setData(tempFilteredResponse);
                    setOgData(tempFilteredResponse);
                    setIsLoading(false);
                }).catch((error:any) => {
                    setIsLoading(false);
                })
                break;
            case 'evidences':
                  setIsLoading(true);
                  const evidenceParams = {
                      clubId: clubDetails?.id,
                      evidenceId: itemId
                  }
                  getEvidenceRestrictions(evidenceParams).then((response:any) => {
                    const restricedUserIds = criteriaRestrictions ? criteriaRestrictions?.filter((cr1:any) => cr1.isRestricted).map((cr:any) => cr.userId) : [];
                    const tempFilteredResponse = response?.map((resItem:any) => {
                        if(restricedUserIds.includes(resItem.id)) {
                            return {...resItem, isDisabled: true};
                          } return resItem;
                        });
                    setData(tempFilteredResponse);
                    setOgData(tempFilteredResponse);
                    setIsLoading(false);
                  }).catch((error:any) => {
                      setIsLoading(false);
                  });
                  break;
            case 'actions':
                  setIsLoading(true);
                  const actionParams = {
                      clubId: clubDetails?.id,
                      actionId: itemId
                  }
                  getActionRestrictions(actionParams).then((response:any) => {
                    const restricedUserIds = criteriaRestrictions?.filter((cr1:any) => cr1.isRestricted).map((cr:any) => cr.userId);
                    const tempFilteredResponse = response?.map((resItem:any) => {
                        if(restricedUserIds.includes(resItem.id)) {
                            return {...resItem, isDisabled: true};
                          } return resItem;
                        });
                    setData(tempFilteredResponse);
                    setOgData(tempFilteredResponse);
                    setIsLoading(false);
                  }).catch((error:any) => {
                      setIsLoading(false);
                  });
                  break;
            case 'licenceCriteria':
                setIsLoading(true);
                const licenceCriteriaParams = {
                    clubId: clubDetails?.id,
                    criteriaId: itemId
                }
                getCriteriaRestrictionsLicence(licenceCriteriaParams).then((response:any) => {
                    setData(response);
                    setOgData(response);
                    setIsLoading(false);
                }).catch((error:any) => {
                    setIsLoading(false);
                })
                break;
            case 'licenceStandards':
                setIsLoading(true);
                const licenceStandardsParams = {
                    clubId: clubDetails?.id,
                    standardId: itemId
                }
                getStandardRestrictionsLicence(licenceStandardsParams).then((response:any) => {
                    const restricedUserIds = criteriaRestrictions?.filter((cr1:any) => cr1.isRestricted).map((cr:any) => cr.userId);
                    const tempFilteredResponse = response?.map((resItem:any) => {
                        if(restricedUserIds.includes(resItem.id)) {
                            return {...resItem, isDisabled: true};
                          } return resItem;
                        });
                    setData(tempFilteredResponse);
                    setOgData(tempFilteredResponse);
                    setIsLoading(false);
                }).catch((error:any) => {
                    setIsLoading(false);
                })
                break;
        }
    }
  }, [isOpen, from, itemId]);
  
  const manageStateChange = (updatedItem: any) => {
    const updatedId = updatedItem?.id;
    const updatedData:any = data?.map((item:any) => {
        if(item.id === updatedId) {
            return updatedItem;
        }
        return item;
    });
    if (updatedCriteriaRestrictions && updatedCriteriaRestrictions?.length > 0) {
      const tempUpdatedCriteriaRestrictions = updatedCriteriaRestrictions?.filter((id:any) => id !== updatedItem?.id);
      setUpdatedCriteriaRestrictions(tempUpdatedCriteriaRestrictions);
    }
    setData(updatedData);
  }

  const manageClickAway = () => {
    const isUpdated = hasUpdates(data, ogData);
    const userIdsWithoutAccess = data.filter((d:any) => d.isRestricted).map((d:any) => d.id);
    if (updatedCriteriaRestrictions !== null && updatedCriteriaRestrictions !== undefined && updatedCriteriaRestrictions?.length > 0) {
      const tempUnRestrictedUsersForAllStandards = unResestrictedUsersForAllStandards && 
                                                    userIdsWithoutAccess &&
                                                    userIdsWithoutAccess?.length > 0 &&
                                                    unResestrictedUsersForAllStandards?.length > 0 &&
                                                    unResestrictedUsersForAllStandards?.filter((num:any) => !userIdsWithoutAccess?.includes(num));
      handleIsOpen(isUpdated, userIdsWithoutAccess, updatedCriteriaRestrictions, tempUnRestrictedUsersForAllStandards);
    } else {
      handleIsOpen(isUpdated, userIdsWithoutAccess);
    }
  }

  const manageAccessForRestrictedUsers = (userData: any) => {
    setAccessPopup({
      isOpen: true,
      accessToUserId: userData?.id,
      userDetails: userData,
      alertMessage: t("ACCESS_MANAGER_RESTRICTED_USER_ALERT_MESSAGE"),
    });
  }

  const manageUserAccessForRestrictedUsers = (theDecision: any) => {
    if (theDecision === t("CONFIRM_FOR_ONLY_THIS_STANDARD") || theDecision === t("CONFIRM_FOR_ALL_THE_STANDARDS")) {
      manageStateChange({...accessPopup?.userDetails, isRestricted: false, isDisabled: false});
      if (criteriaRestrictions != null || criteriaRestrictions != undefined) {
        var removeRestrictionsIds:any = []; 
        criteriaRestrictions?.map((crItem: any) => {
          if (crItem?.userId === accessPopup?.accessToUserId) {
            removeRestrictionsIds.push(crItem?.userId);
          }
        });
        setUpdatedCriteriaRestrictions(updatedCriteriaRestrictions ? [...updatedCriteriaRestrictions, ...removeRestrictionsIds] : removeRestrictionsIds);
        if(theDecision === t("CONFIRM_FOR_ALL_THE_STANDARDS")) {
          const tempAllUsers:any = [...unResestrictedUsersForAllStandards, accessPopup?.accessToUserId];
          setUnResestrictedUsersForAllStandards(tempAllUsers)
        }
      }
    }
    setAccessPopup(accessPopupInitialData);
    setAnchorEl(null);
  }

  const manageUserAccessConfirmationPopup = (isConfirmed: any) => {
    if (isConfirmed) {
      manageStateChange({...confirmationPopup?.userDetails, isRestricted: !confirmationPopup?.userDetails?.isRestricted});
    } else {
      manageStateChange({...confirmationPopup?.userDetails, isRestricted:  confirmationPopup?.userDetails?.isRestricted});
    }
    setConfirmationPopup(confirmationPopupInitialData);
    setAnchorEl(null);
  }

  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        <Popper className="popperStyle" open={isOpen} transition>
          {({ TransitionProps }) => (
            <ClickAwayListener
              onClickAway={manageClickAway}
            >
              <Fade {...TransitionProps} timeout={350}>
                <Paper
                  sx={{
                    width: "400px",
                    height: "60vh",
                    margin: "auto",
                    mt: "10vh",
                    padding: "10px",
                  }}
                  onClick={() => handleClickInsidePopper}
                >
                  <Typography sx={{ fontSize: "18px", fontWeight: 700 }}>
                    {t("TDM_MANAGE_ACCESS")}
                  </Typography>
                  <TableContainer sx={{ height: "90%", overflowY: "auto", mt: 2 }}>
                    <Table stickyHeader size="small" aria-label="a dense table">
                      <EnhancedTableHead
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={handleRequestSort}
                        tableHeads={head}
                        bg={"#fff"}
                      />
                      <TableBody>
                        {!isLoading && visibleRows?.length ? (
                          visibleRows.map((d: any, i: number) => {
                            const isCurrentUser = user?.id === d.id;
                            return (
                              <TableRow
                                className={(isCurrentUser) ? "hoverBG cursorNotAllowed" : "hoverBG"}
                                sx={{ cursor: "pointer" }}
                                key={`accessmanager-table-row-${i}`}
                                onClick={(e) => { 
                                  e.stopPropagation();
                                  setAnchorEl(e.currentTarget);
                                  if (d?.isDisabled && !isCurrentUser) {
                                    manageAccessForRestrictedUsers(d);
                                  } else if ((d?.isRestricted || (from === "evaluationStandards" || from === "licenceStandards")) && !isCurrentUser) {
                                    manageStateChange({...d, isRestricted: !d?.isRestricted});
                                  } else if (!isCurrentUser) {
                                    setConfirmationPopup({
                                      isOpen: true,
                                      accessToUserId: d?.id,
                                      userDetails: d,
                                      alertMessage: t("AM_CONFIRMATION_ALERT_MESSAGE"),
                                    })
                                  }}} >
                                <TableCell className="fs12" sx={{ width: '70%' }}>
                                    <AvatarAndName 
                                    avatarName={isCurrentUser ? d.firstName + ' ' + d.lastName + ` (${t('YOU')})` : d.firstName + ' ' + d.lastName} 
                                    avatarImage={d.avatar ? `${baseUrl}/Content${d.avatar}` : ''}/>
                                </TableCell>
                                <TableCell
                                className="fs12"
                                align="center">
                                  {
                                    !d?.isDisabled ?
                                    <Box
                                      className="alertBoxParent"
                                      // onClick={(e: any) => {
                                      //   e.stopPropagation();
                                      //   setAnchorEl(e.currentTarget);
                                      // }}
                                    >
                                      {/* enable to have checkbox style */}
                                        {/* <Checkbox
                                            checked={!d?.isRestricted}
                                            disabled={isCurrentUser}
                                            onClick={() => { (d?.isRestricted || (from === "evaluationStandards" || from === "licenceStandards")) ?
                                              !isCurrentUser && manageStateChange({...d, isRestricted: !d?.isRestricted}) :
                                              setConfirmationPopup({
                                                isOpen: true,
                                                accessToUserId: d?.id,
                                                userDetails: d,
                                                alertMessage: t("ACCESS_MANAGER_CONFIRMATION_ALERT_MESSAGE_CRITERIA"),
                                              })}}
                                        /> */}
                                        {/* lock/unlock style implementation */}
                                        
                                      <Tooltip title={d?.isRestricted && !hideTooltip && t("STANDARD_RESTRICTED_USER")} arrow placement="right">
                                        <FontAwesomeIcon 
                                        className={d?.isRestricted ? 'icon closedLock' : 'icon openLock'} 
                                        aria-disabled={isCurrentUser}
                                        icon={d?.isRestricted ? faLock : faLockOpen}/>
                                      </Tooltip>
                                    </Box> :
                                    <Box
                                      className="alertBoxParent"
                                      // onClick={(e: any) => {
                                      //   e.stopPropagation();
                                      //   setAnchorEl(e.currentTarget);
                                      // }}
                                    >
                                      <Tooltip title={!hideTooltip &&t("CRITERIA_RESTRICTED_USER")} arrow placement="right">
                                        <FontAwesomeIcon className={'icon closedLock'} icon={faLock} />
                                      </Tooltip>
                                    </Box>
                                  }
                                </TableCell>
                              </TableRow>
                            );
                          })
                        ) : !isLoading &&
                          (visibleRows?.length == 0 ||
                            visibleRows == undefined) ? (
                          <TableRow>
                            <TableCell
                              colSpan={head?.length}
                              className="fs12"
                              align="center"
                            >
                              No Records Found
                            </TableCell>
                          </TableRow>
                        ) : (
                          isLoading && (
                            <TableSkeleton
                              rowCount={10}
                              cellCount={head?.length}
                            />
                          )
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <AlertPopup
                    alertMessage={accessPopup?.alertMessage}
                    isOpen={accessPopup?.isOpen}
                    confirmMessages={[t("CONFIRM_FOR_ONLY_THIS_STANDARD"), t("CONFIRM_FOR_ALL_THE_STANDARDS")]}
                    handleClose={(returnedDecision: any) => {
                      manageUserAccessForRestrictedUsers(returnedDecision);
                    }}
                    anchor={anchorEl}
                  />
                  <AlertPopup
                    alertMessage={confirmationPopup?.alertMessage}
                    isOpen={confirmationPopup?.isOpen}
                    handleClose={(isConfirmed: any) => {
                      manageUserAccessConfirmationPopup(isConfirmed);
                    }}
                    anchor={anchorEl}
                  />
                </Paper>
              </Fade>
            </ClickAwayListener>
          )}
        </Popper>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default AccessManager;
